const UploadPreview = props => {
  const {
    src,
    width,
    height,
    progressBar
  } = props;

  let style = {
    height: '75%',
    marginTop: '44px'
  }

  let imgStyle = {
    display: 'block',
    height: '262px',
    width: `${parseInt(width / height * 262)}px`,
    margin: '0 auto'
  }

  let progressBarStyle = {
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    padding: '1rem',
    color: '#fff'
  }

  return (
    <div style={style}>
      <img src={src} style={imgStyle} />
      <div style={progressBarStyle}>
	{progressBar}
      </div>
    </div>
  )
}

export default UploadPreview;
